<template>
    <Bank :id="Number(0)"/>
</template>
<script>
import Bank from '@/components/BankProduct.vue';

export default {
    components: {
        Bank
    }
}
</script>